module.exports = __webpack_public_path__ + "static/media/ig4.8bfffc3b.jpg";